
export enum ReportRunProgressState {
    Requested,
    DataCollection,
    PopulateData,
    RowCreation,
    DocumentCreation,
    Finished
}
